export function MenuItem(
  { routeName = "", text = "", click = null }
) {
  return {
    routeName,
    text,
    click,
  }
}
